import { authState } from "./AuthState.svelte";
import { isEmpty } from "lodash-es";
import { parseBool } from "$lib/shared/utils/lodash-extensions";
import LocalStorageHelpers from "$lib/shared/utils/local-storage-helpers";
import { SUPPRESS_CONFIG_DOCS_MODAL_KEY } from "$lib/shared/constants";

export let appState = $state({
    config: {
        keyCloakRealm: "global",
        keyCloakUrl: "",
        keyCloakClientId: "arc-ui",
        keyCloakLogoutRedirect: "",
        apiKey: ""
    }
});

const getTenantSpecificKey = key => isEmpty(authState.currentTenant?.clientId)
    ? null
    : `${authState.currentTenant.clientId}:${key}`;

export function getSupressConfigDocsModalValue() {
    let storageKey = getTenantSpecificKey(SUPPRESS_CONFIG_DOCS_MODAL_KEY);
    return LocalStorageHelpers.getBool(storageKey);
}

export function setSupressConfigDocsModalValue(value=null) {
    let storageKey = getTenantSpecificKey(SUPPRESS_CONFIG_DOCS_MODAL_KEY);
    LocalStorageHelpers.setBool(storageKey, value);
}